<template>
  <div>
    <h5 class="title-container">
      <strong>{{ $t('SAAI.SetComment.title') }}</strong>
    </h5>
    <div class="feedback-comment-description">
      <p><strong>{{ $t('SAAI.SetComment.explanation1') }}</strong>{{ $t('SAAI.SetComment.explanation2') }}</p>
      <p>{{ $t('SAAI.SetComment.explanation3') }}<strong>{{ $t('SAAI.SetComment.explanation4') }}</strong>{{ $t('SAAI.SetComment.explanation5') }}</p>
      <div class="example">
        <p class="example-title">{{ $t('SAAI.SetComment.example1') }}</p>
        <p>{{ $t('SAAI.SetComment.example2') }}</p>
        <p>{{ $t('SAAI.SetComment.example3') }}</p>
      </div>
    </div>
    <div v-for="i in this.numberOfSheets" :key="i">
      <div class="question flex-col">
        <p id="input-text" class="question-text">
          <b>{{
            $t('SAAI.CreateImprovedFeedback.CommentSetting.question') + ' ' + (i) + ' : ' + questions[i - 1]
          }}</b>
        </p>
        <textarea rows="7" cols="50" v-model="feedbackComments[i - 1]"> </textarea>
      </div>
    </div>
    <div class="button-wrapper">
      <button @click="() => moveNextStep()">
        {{ $t('SAAI.CreateGradingPaper.UploadingGradingPaper.nextButton') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ImprovedFeedbackCommentSetting',
  data() {
    return {
      feedbackComments: [],
    };
  },
  computed: {
    ...mapState('saaiImprovedFeedback', {
      questions: (state) => state.questions,
      numberOfSheets: (state) => state.numberOfSheets,
    }),
  },
  created() {
    this.feedbackComments = Array(this.numberOfSheets).fill('다음의 단어는 답안을 잘 작성한 다른 친구가 많이 사용한 단어입니다. 이 단어들을 응답에 어떻게 포함시킬 지 생각해볼까요?');
  },
  methods: {
    ...mapActions('saaiImprovedFeedback', [
      'AC_SET_ADDITIONAL_FEEDBACK',
    ]),
    async moveNextStep() {
      this.setCommentSetting();

      this.$router.push('downloadImprovedFeedback');
    },
    setCommentSetting() {
      this.AC_SET_ADDITIONAL_FEEDBACK(this.feedbackComments);
    }
  },
};
</script>

<style lang="scss">
.question {
  margin: 15px 0;
  padding: 15px 15px;
  border: 2px solid $MAIN-COLOR;
  border-left: 1.5px solid $MAIN-COLOR;
  border-right: 1.5px solid $MAIN-COLOR;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-radius: 5px;
}

#input-text {
  margin-bottom: 15px;
}

.question-text {
  margin-left: 10px;
}

textarea {
  padding: 10px;
}

.feedback-comment-description {
  margin-bottom: 25px;
}

.title-container {
  display: block;
  margin-bottom: 25px;

  strong {
    color: $MAIN-COLOR;
    border-bottom: 2px solid $MAIN-COLOR;
    padding: 5px 30px;
  }
}

.example {
  margin-top: 5px;
  color: red;
}

.example-title {
  font-weight: bold;
}
</style>
